'use strict';

class FaqList {
    constructor() {

        const h2s = document.querySelectorAll('h2.expand-collapse');

        [].forEach.call(h2s, (h2) => {
            const siblings = this.nextUntil(h2, 'h2.expand-collapse');
            if (siblings.length === 0) {
                h2.classList.remove('expand-collapse');
                return;
            }
            const wrapper = document.createElement('div');
            wrapper.classList.add('expand-collapse');
            siblings[0].before(wrapper);
            siblings.forEach(x => wrapper.append(x));
            h2.addEventListener('click', (e) => {
                h2.classList.toggle('show');
                h2.nextElementSibling.classList.toggle('show');
            });
        });

        
    }

    nextUntil(elem, selector, filter) {

        // matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }

        // Setup siblings array
        var siblings = [];

        // Get the next sibling element
        elem = elem.nextElementSibling;

        // As long as a sibling exists
        while (elem) {

            // If we've reached our match, bail
            if (elem.matches(selector)) break;

            // If filtering by a selector, check if the sibling matches
            if (filter && !elem.matches(filter)) {
                elem = elem.nextElementSibling;
                continue;
            }

            // Otherwise, push it to the siblings array
            siblings.push(elem);

            // Get the next sibling element
            elem = elem.nextElementSibling;

        }

        return siblings;

    };
}

document.addEventListener("DOMContentLoaded", function () {
    new FaqList();
});


// WEBPACK FOOTER //
// ./Components/Blocks/FaqBlock/faqblock.js